import React from 'react';

import Faq from '../../../components/Molecules/Faq';

const NodeFaq = ({ entity, className }) => (
  <Faq
    className={className}
    question={entity.getIn(['title', 0, 'value'], '')}
    answer={entity.getIn(['field_answer', 0, 'processed'], '')}
  />
);

export default NodeFaq;
